/* Config */
import Config from '../../appConfig'

/* Utils */
import {generateCampaignModel, generateOtherSellerCampaign, generateOtherSellerCoupon} from './productCommonUtils'
import {getAuthorizationHeaderWithBearer} from '../../common/network/apiUtils'
import {getBrowserCookie} from '../../../client/common/persistence/browserCookieUtils'
import {DAVINCI_PAGE_TYPES} from '../analytics/davinci/davinciConstants'

/* Constants */
import {CATEGORY_PAGE_ANDROID_TARGET_BRANDS} from '../category/categoryConstants';

function productApiFactory(storefrontApiClient) {
  const productApi = {
    getProduct(sku, params, isProductId) {
      const requestUrl = isProductId ? `productDetail/productId/${sku}` : `productDetail/sku/${sku}`
      return storefrontApiClient.get(requestUrl, {
        params: {
          merchant: params?.magaza,
          name: params?.name,
          channel: params?.channel,
          isBot: params?.isBot,
          ...params
        },
        timeout: Config.hermesTimeoutInMilliseconds,
      });
    },
    getSplitProductVariants(sku, params) {
      return storefrontApiClient.get(`product/sku/${sku}/variants`, {
        params,
        timeout: Config.hermesTimeoutInMilliseconds,
      });
    },
    getProductReturnPolicy(sku, params) {
      return storefrontApiClient.get(`product/returnPolicy/${sku}`, {
        params,
        timeout: Config.defaultTimeoutInMilliseconds,
      });
    },
    getSizeChart(params) {
      return storefrontApiClient.get('sizeChart', {
        params,
        timeout: Config.defaultTimeoutInMilliseconds,
      });
    },
    getCardAndInstallment(params) {
      return storefrontApiClient.get('product/installment', {
        params,
        timeout: Config.installmentTimeoutInMilliseconds,
      });
    },
    getCampaignsPdpDashboard({...params}) {
      return storefrontApiClient.post(`${Config.campaignApiUrl}/v2/Campaign/pdp`,
        generateCampaignModel(params?.product, params?.userInfo, 'WebSite', 'WebSite'), {
          timeout: Config.defaultTimeoutInMilliseconds,
        })
    },
    getDueDate(params) {
      return storefrontApiClient.post(`${Config.shippingApiUrl}/duedateapi/querymodel/withtext/v2`, params, {
        timeout: Config.defaultTimeoutInMilliseconds,
      });
    },
    getDueDateProducts(params) {
      return storefrontApiClient.post(`${Config.shippingApiUrl}/duedateapi/queryModel/withtext/v3`, params, {
        timeout: Config.defaultTimeoutInMilliseconds,
      });
    },
    getProductListings(sku, params) {
      return storefrontApiClient.get(`product/listings/${sku}`, {
        params,
        timeout: 1000 * 10
      });
    },
    getVas({params}) {
      return storefrontApiClient.post(`${Config.customerVoltranGatewayApiUrl}/vas/evaluate`,
        params,
      );
    },
    getOtherSellerCampaigns({...params}) {
      return storefrontApiClient.post(`${Config.campaignApiUrl}/v1/Campaign/otherSellers/campaignCount`,
        generateOtherSellerCampaign(params?.sku, params?.allListings), {
          timeout: 5 * 1000,
          withCredentials: true
        })
    },
    getOtherSellerCoupon({...params}) {
      return storefrontApiClient.post(`${Config.campaignApiUrl}/v1/Coupon/otherSellers/couponCount`,
        generateOtherSellerCoupon(params?.product), {
          timeout: 5 * 1000,
          withCredentials: true
        })
    },
    getComparedProducts(params = {}) {
      const specialBrands = [
        'Apple',
        'Dyson',
        'NYX Professional Makeup',
        'L\'Oréal Paris',
        'Maybelline New York',
        'Garnier',
        'Elseve',
        'L\'Oréal Paris Men Expert',
        'Garnier Ambre Solaire',
        'İpek',
        'Garnier Men',
        'Parmex'
      ]

      const isIphoneCategory = params?.categoryId === '60005202'

      const comparedProductsApiParams = {
        size: 4,
        categoryId: params?.categoryId,
        q: params?.searchTerm,
      }

      if (params?.brand) {
        if (params?.pageType === DAVINCI_PAGE_TYPES.PRODUCT_DETAIL_PAGE) {
          comparedProductsApiParams.brand = specialBrands.includes(params?.brand) ? params?.brand : null;
        } else {
          comparedProductsApiParams.brand = params?.brand;

          const isAndroidCategory = params?.categoryId === '60005201'

          if (params?.pageType === DAVINCI_PAGE_TYPES.CATEGORY && isAndroidCategory) {

            if (CATEGORY_PAGE_ANDROID_TARGET_BRANDS.includes(params?.brand)) {
              comparedProductsApiParams.sku = params?.sku
            }
          }
        }
      }

      if (isIphoneCategory) {
        comparedProductsApiParams.sku = params?.sku
      }

      return storefrontApiClient.get('product/top-selling', {
        params: comparedProductsApiParams,
        timeout: Config.defaultTimeoutInMilliseconds,
      });
    },
    getBasicProduct(sku, params, isProductId) {
      const requestUrl = isProductId ? `productBasic/productId/${sku}` : `productBasic/sku/${sku}`
      return storefrontApiClient.get(requestUrl, {
        params: {
          merchant: params?.magaza,
          name: params?.name,
          channel: params?.channel,
          isBot: params?.isBot,
          ...params
        },
        timeout: Config.hermesTimeoutInMilliseconds,
      });
    },
  }

  return productApi
}

export default productApiFactory
